import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import type { QueryClient } from '@tanstack/react-query'
import { NotFound } from '../components/NotFound'
import { ToastProvider } from '../components/Toast'
import { ButtonLink, EmptyState } from '../components/ui'

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: () => (
    <ToastProvider>
      <Outlet />
    </ToastProvider>
  ),
  notFoundComponent: NotFound,
  errorComponent: ({ error }) => (
    <div className="mx-auto grid min-h-dvh max-w-md content-center px-4">
      <EmptyState title="Something broke" action={<ButtonLink to="/" variant="primary" size="sm">Go home</ButtonLink>}>
        {error instanceof Error ? error.message : 'Try again in a moment.'}
      </EmptyState>
    </div>
  ),
})
